/**
 * novaStateMap — translate the OLD `NovaState` union used by
 * `inferChatMood`, milestone copy, etc. into the NEW `NovaExpressionId`
 * catalog. Two hyphenated old names need renaming; the other 9 are
 * literally the same string.
 *
 * Kept small and pure so surfaces can swap `<Nova state={s}/>` for
 * `<NovaExpression id={mapNovaState(s)}/>` in one line.
 */
import type { NovaExpressionId } from './nova-expressions';

// Old union re-declared here rather than imported so this file has no
// cycle with `Nova.tsx` — the eventual goal is to delete that file.
export type LegacyNovaState =
  | 'idle'
  | 'curious'
  | 'thinking'
  | 'has-suggestion'
  | 'happy'
  | 'sleepy'
  | 'celebrating'
  | 'camera-ready'
  | 'sad'
  | 'cross'
  | 'shocked';

export function mapNovaState(state: LegacyNovaState | undefined): NovaExpressionId {
  switch (state) {
    case 'has-suggestion': return 'suggestion';
    case 'camera-ready':   return 'camera';
    case undefined:        return 'idle';
    default:               return state;
  }
}
